import type { EndpointBuilder } from '@reduxjs/toolkit/query'

import { rootApi } from 'root-api'

import { MEETINGS_TAG_TYPES } from './constants'
import { buildMutations } from './mutations'
import { buildQueries } from './queries'

/**
 * Shared meetings REST API.
 * This API is used by both the meetings feature and the realtime meetings feature.
 * We pass the enhanced API into buildMutations so mutation lifecycle callbacks
 * (e.g. applyNoShowResponseToCache) can use api.util.updateQueryData; RTK Query
 * does not pass api in the onQueryStarted second argument.
 */
const enhancedApi = rootApi.enhanceEndpoints({ addTagTypes: MEETINGS_TAG_TYPES })
export const meetingsRestApi = enhancedApi.injectEndpoints({
  endpoints: (build: EndpointBuilder<any, any, any>) => ({
    ...buildQueries(build),
    ...buildMutations(build, enhancedApi as any)
  })
})

export const {
  useBlockInviteeMutation,
  useBookPollMutation,
  useCancelInviteeMutation,
  useCancelMeetingMutation,
  useDeletePendingEventMutation,
  useGetBuffersQuery,
  useGetInviteesQuery,
  useGetMeetingQuery,
  useGetMeetingsQuery,
  useGetPollResultsQuery,
  useGetScopeInfoQuery,
  useGetTimelineDataQuery,
  useLazyGetInviteesQuery,
  useLazyGetMeetingQuery,
  useLookupUuidsQuery,
  useMarkInviteeAsNoShowMutation,
  useUnblockInviteeMutation,
  useUndoNoShowForInviteeMutation,
  useUpdateBufferMutation,
  useUpdateEventAttributesMutation,
  useUpdateInviteeMutation,
  useUpdateMeetingMutation
} = meetingsRestApi
